import { render, staticRenderFns } from "./SearchbaseDrugResultItem.vue?vue&type=template&id=00041554&scoped=true&"
import script from "./SearchbaseDrugResultItem.vue?vue&type=script&lang=js&"
export * from "./SearchbaseDrugResultItem.vue?vue&type=script&lang=js&"
import style0 from "./SearchbaseDrugResultItem.vue?vue&type=style&index=0&id=00041554&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00041554",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VListItem,VListItemContent,VListItemSubtitle,VListItemTitle})
